const validate = (values) => {
  const errors = {};
  if (!values.currentPass) {
    errors.currentPass = 'Informe a senha atual';
  }

  if (!values.newPass) {
    errors.newPass = 'Informe a nova senha';
  }

  if (values.confirmPass !== values.newPass) {
    errors.confirmPass = 'As senhas não correspondem';
  }

  return errors;
};

export default validate;
